/* AlpenGravur Weihnachtsmodus: Schneefall, Countdown, Textideen.
   Wird nur geladen, wenn der Modus aktiv ist (layout/theme.liquid). */
(function(){
  'use strict';
  var root = document.documentElement;
  if(!root.classList.contains('xmas')) return;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var KEY = 'ag-snow';
  var SNOW_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M12 2v20M3.3 7l17.4 10M20.7 7L3.3 17"/><path d="M9.5 3.8L12 6.3l2.5-2.5M9.5 20.2L12 17.7l2.5 2.5M3 10.4l3.4.9-.9 3.4M21 10.4l-3.4.9.9 3.4M3 13.6l3.4-.9-.9-3.4M21 13.6l-3.4-.9.9-3.4"/></svg>';

  function ready(fn){
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn();
  }
  function readPref(){ try { return window.localStorage.getItem(KEY); } catch(e){ return null; } }
  function writePref(v){ try { window.localStorage.setItem(KEY, v); } catch(e){} }
  function make(tag, cls, html){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(html != null) n.innerHTML = html;
    return n;
  }

  /* ---------------- Schneefall ---------------- */
  var snow = null;

  function initSnow(){
    var canvas = make('canvas', 'xmas-snow');
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if(!ctx) return;

    var w = 0, h = 0, dpr = 1, flakes = [], bursts = [];
    var wind = 0, windTarget = 0, pointerWind = 0, t0 = 0, last = 0, raf = 0;
    var enabled = false;

    function target(){
      return w < 700 ? 34 : Math.round(Math.min(150, Math.max(45, w / 11)));
    }
    function flake(randomY){
      var depth = Math.random();
      var r = 0.8 + depth * depth * 2.9;
      return {
        x: Math.random() * w,
        y: randomY ? Math.random() * h : -10 - Math.random() * 40,
        r: r,
        vy: 22 + r * 15 + Math.random() * 14,
        drift: 8 + Math.random() * 16,
        ph: Math.random() * Math.PI * 2,
        sp: 0.5 + Math.random() * 0.9,
        a: 0.55 + depth * 0.4
      };
    }
    function resize(){
      dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 700 ? 1.5 : 2);
      w = window.innerWidth; h = window.innerHeight;
      canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = target();
      while(flakes.length < n) flakes.push(flake(true));
      if(flakes.length > n) flakes.length = n;
    }
    function frame(ts){
      raf = 0;
      if(document.hidden) return;
      if(!last) last = ts;
      var dt = Math.min(0.05, (ts - last) / 1000); last = ts;
      var t = (ts - t0) / 1000;
      ctx.clearRect(0, 0, w, h);

      if(enabled){
        windTarget = Math.sin(t * 0.17) * 14 + pointerWind;
        wind += (windTarget - wind) * Math.min(1, dt * 1.2);
        for(var i = 0; i < flakes.length; i++){
          var f = flakes[i];
          f.y += f.vy * dt;
          f.x += (Math.sin(t * f.sp + f.ph) * f.drift + wind * (0.4 + f.r * 0.25)) * dt;
          if(f.y > h + 8){ flakes[i] = flake(false); continue; }
          if(f.x < -10) f.x = w + 10; else if(f.x > w + 10) f.x = -10;
          ctx.globalAlpha = f.a;
          ctx.fillStyle = '#fff';
          ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.2832); ctx.fill();
          if(f.r > 1.5){
            ctx.globalAlpha = f.a * 0.55;
            ctx.strokeStyle = 'rgba(112,136,160,.8)';
            ctx.lineWidth = 0.6;
            ctx.stroke();
          }
        }
      }

      for(var j = bursts.length - 1; j >= 0; j--){
        var p = bursts[j];
        p.life -= dt;
        if(p.life <= 0){ bursts.splice(j, 1); continue; }
        p.vy += 260 * dt; p.x += p.vx * dt; p.y += p.vy * dt;
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life / p.max));
        ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;

      if(enabled || bursts.length) raf = window.requestAnimationFrame(frame);
    }
    function kick(){
      if(!raf && !document.hidden){ last = 0; raf = window.requestAnimationFrame(frame); }
    }

    snow = {
      setEnabled: function(on){
        enabled = !!on;
        if(!enabled && !bursts.length){ ctx.clearRect(0, 0, w, h); }
        if(enabled) kick();
      },
      burst: function(x, y){
        if(reduceMotion) return;
        var cols = ['#FFFFFF', '#F5C04E', '#FFD9A0', '#FF9A8F', '#D9A85E'];
        for(var i = 0; i < 22; i++){
          var ang = -Math.PI / 2 + (Math.random() - 0.5) * 2.3;
          var sp = 90 + Math.random() * 190;
          var life = 0.7 + Math.random() * 0.6;
          bursts.push({ x: x, y: y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, r: 1.2 + Math.random() * 2.2, c: cols[i % cols.length], life: life, max: life });
        }
        kick();
      }
    };

    t0 = performance.now();
    resize();
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function(){ if(!document.hidden) kick(); });
    window.addEventListener('pointermove', function(e){
      pointerWind = ((e.clientX / Math.max(1, w)) - 0.5) * 36;
    }, { passive: true });
  }

  function initToggle(defaultOn){
    var pref = readPref();
    var on = pref === 'on' ? true : pref === 'off' ? false : defaultOn;
    var btn = make('button', 'xmas-snow-toggle', SNOW_ICON);
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Schneefall ein- oder ausschalten');
    btn.title = 'Schneefall ein/aus';
    function apply(){
      btn.setAttribute('aria-pressed', String(on));
      if(snow) snow.setEnabled(on);
    }
    btn.addEventListener('click', function(){ on = !on; writePref(on ? 'on' : 'off'); apply(); });
    document.body.appendChild(btn);
    apply();
  }

  /* ---------------- Countdown auf der Startseite ---------------- */
  function countdownHTML(now){
    var y = now.getFullYear(), m = now.getMonth(), d = now.getDate();
    var snowSvg = SNOW_ICON;
    if(m === 11 && d >= 27) return snowSvg + 'Ein gutes neues Jahr ' + (y + 1);
    if(m === 0 && d <= 6) return snowSvg + 'Ein gutes neues Jahr ' + y;
    if(m === 11 && d >= 25) return snowSvg + 'Frohe Weihnachten';
    if(m === 11 && d === 24) return snowSvg + 'Heute ist <b>Heiligabend</b>';
    var today = new Date(y, m, d), eve = new Date(y, 11, 24);
    var days = Math.round((eve - today) / 86400000);
    if(days < 0 || days > 120) return '';
    return snowSvg + 'Noch <b>' + days + '</b> ' + (days === 1 ? 'Tag' : 'Tage') + ' bis Heiligabend';
  }
  function initCountdown(){
    var hero = document.querySelector('.hero .hero-inner > div');
    if(!hero || hero.querySelector('.xmas-countdown')) return;
    var html = countdownHTML(new Date());
    if(!html) return;
    var pill = make('div', 'xmas-countdown', html.replace(/^(<svg.*?<\/svg>)(.*)$/, '$1<span>$2</span>'));
    pill.setAttribute('role', 'status');
    hero.insertBefore(pill, hero.firstChild);
  }

  /* ---------------- Footer-Gruss ---------------- */
  function initFooterLine(){
    var bottom = document.querySelector('footer .foot-bottom');
    if(!bottom || document.querySelector('.xmas-foot-line')) return;
    var line = make('div', 'container xmas-foot-line', '<span>✦</span>Frohe Weihnachten aus Altenmarkt im Pongau<span>✦</span>');
    bottom.parentNode.insertBefore(line, bottom);
  }

  /* ---------------- 404 ---------------- */
  function init404(){
    var box = document.querySelector('body.template-404 .empty-state .container');
    if(!box || box.querySelector('.xmas-404-note')) return;
    var p = box.querySelector('p');
    var note = make('p', 'xmas-404-note', 'Selbst das Christkind hat sich hier verirrt.');
    if(p && p.nextSibling) box.insertBefore(note, p.nextSibling); else box.appendChild(note);
  }

  /* ---------------- Textideen ---------------- */
  function xmasYear(){
    var n = new Date();
    return n.getMonth() <= 1 ? n.getFullYear() - 1 : n.getFullYear();
  }
  function ideas(){
    return ['Frohe Weihnachten', 'Merry Christmas', 'Ho Ho Ho', 'Von Herzen', 'Weihnachten ' + xmasYear()];
  }
  function buildChips(maxLen, onPick){
    var wrap = make('div', 'xmas-chips');
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Weihnachtliche Textideen');
    wrap.appendChild(make('span', 'xmas-chips__label', 'Weihnachtliche Textideen'));
    ideas().forEach(function(text){
      if(maxLen && text.length > maxLen) return;
      var b = make('button', 'xmas-chip');
      b.type = 'button'; b.textContent = text;
      b.addEventListener('click', function(){ onPick(text); });
      wrap.appendChild(b);
    });
    return wrap;
  }
  function fillInput(input, text){
    input.value = text;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }
  function initProductChips(){
    var input = document.getElementById('PdpPersonalization');
    if(!input || document.querySelector('.xmas-chips')) return;
    var max = parseInt(input.getAttribute('maxlength'), 10) || 0;
    var field = input.closest('.pdp-engrave-field') || input.parentNode;
    var meta = field.querySelector('.config-meta');
    var chips = buildChips(max, function(text){ fillInput(input, text); });
    if(meta && meta.nextSibling) field.insertBefore(chips, meta.nextSibling); else field.appendChild(chips);
  }

  /* ---------------- Klick-Funken beim In-den-Warenkorb ---------------- */
  function initSparks(){
    document.addEventListener('click', function(e){
      if(!snow || !e.target || !e.target.closest) return;
      var hit = e.target.closest('.prod-add, [data-add-to-cart], form[action*="/cart/add"] button[type="submit"], #PdpForm button[type="submit"]');
      if(!hit || hit.disabled) return;
      var r = hit.getBoundingClientRect();
      snow.burst(r.left + r.width / 2, r.top + r.height / 2);
    });
  }

  /* Werkstatt (workshop.js) ruft das nach dem Rendern der Textsteuerung auf. */
  window.AGXmas = { buildChips: buildChips, fillInput: fillInput };

  ready(function(){
    var wantSnow = root.getAttribute('data-xmas-snow') !== '0';
    if(wantSnow){
      initSnow();
      initToggle(!reduceMotion);
    }
    if(root.getAttribute('data-xmas-countdown') !== '0') initCountdown();
    initFooterLine();
    init404();
    initProductChips();
    initSparks();
  });
})();
